import { FETCH_ORDER_DETAIL_SUCCEEDED, GET_ORDER_USER_PROFILE, MAP_LOCATION_TO_ORDER_ITEM, GET_ORDER_LOGS } from './detail.actions';
import * as _ from 'lodash';

export const detail = (state = { fetched: false, data: {} }, action) => {
  switch (action.type) {
    case FETCH_ORDER_DETAIL_SUCCEEDED:
      return _.assign({}, state, { fetched: true, data: action.data });

    case GET_ORDER_USER_PROFILE:
      return _.assign({}, state, {
        user: action.data
      });
    case GET_ORDER_LOGS:
      return _.assign({}, state, {
        paymentLogs: action.data.search((s) => s ? s.name.indexOf('order_payment') > -1 : false),
        deliveryLogs: action.data.search((s) => s ? s.name.indexOf('order_delivery') > -1 : false)
      });
    case MAP_LOCATION_TO_ORDER_ITEM:
      return _.assign(
        {},
        state,
        {
          data: _.assign(_.clone(state.data), {
            products: _.map((state as any).data.products, item => {
              const location = _.find(action.data, i => i.getId() === item.location_id);
              if (location) {
                return _.assign(item, {
                  location: location
                });
              }
              return item;
            })
          })
        }
      );

    default:
      return state;
  }
};
